import React from 'react';
import Box from 'components/Box';
import Icon from 'components/Icon';
import VisuallyHidden from 'components/VisuallyHidden';
function AvatarDot(_ref) {
  var label = _ref.label;
  return /*#__PURE__*/React.createElement(Box, {
    position: "absolute",
    top: -7,
    right: -7,
    lineHeight: 0
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "dot",
    color: "highlight",
    scale: 1.2
  }), /*#__PURE__*/React.createElement(VisuallyHidden, null, label));
}
export default AvatarDot;